import type { ReactNode } from 'react';

export const symbol_team_dashboard: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24.75 0-42.37-17.63Q120-155.25 120-180v-600q0-24.75 17.63-42.38Q155.25-840 180-840h600q24.75 0 42.38 17.62Q840-804.75 840-780v600q0 24.75-17.62 42.37Q804.75-120 780-120H180Zm230-60v-270H180v270h230Zm60 0h310v-270H470v270ZM180-510h600v-270H180v270Z"
		/>
	</svg>
);
